import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const VideoAdd = ({ strokeWidth = 1.5 }): JSX.Element => <g id={'contour'}>
    <path
        d='M22 9V15C22 15.23 22 15.45 21.98 15.67C21.94 15.61 21.89 15.55 21.84 15.5C21.83 15.49 21.82 15.47 21.81 15.46C21 14.56 19.81 14
         18.5 14C17.24 14 16.09 14.52 15.27 15.36C14.48 16.17 14 17.28 14 18.5C14 19.34 14.24 20.14 14.65 20.82C14.87 21.19 15.15 21.53 15.47
          21.81C15.49 21.82 15.5 21.83 15.51 21.84C15.56 21.89 15.61 21.93 15.67 21.98C15.46 22 15.23 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9
           2H15C20 2 22 4 22 9Z'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
    />
    <path d='M2.52002 7.10999H21.48' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
    <path d='M8.52002 2.10999V6.96997' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
    <path d='M15.48 2.10999V6.52002' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
    <path
        d='M23 18.5C23 18.86 22.96 19.21 22.87 19.55C22.76 20 22.58 20.43 22.35 20.82C21.57 22.12 20.14 23 18.5 23C17.42 23 16.44 22.62 15.68
         21.98C15.67 21.98 15.67 21.98 15.67 21.98C15.61 21.93 15.56 21.89 15.51 21.84C15.5 21.83 15.49 21.82 15.47 21.81C15.15 21.53 14.87
          21.19 14.65 20.82C14.24 20.14 14 19.34 14 18.5C14 17.28 14.48 16.17 15.27 15.36C16.09 14.52 17.24 14 18.5 14C19.81 14 21 14.56 21.81
           15.46C21.82 15.47 21.83 15.49 21.84 15.5C21.89 15.55 21.94 15.61 21.98 15.67C22.62 16.44 23 17.43 23 18.5Z'
        strokeWidth={strokeWidth}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
    />
    <path d='M20.1801 18.48H16.8201' strokeWidth={strokeWidth} strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round'/>
    <path d='M18.5 16.8401V20.2001' strokeWidth={strokeWidth} strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round'/>
</g>;

export default createSvg(
    VideoAdd,
    'video-add',
);
